import getConfig from 'next/config'

import { PublicApiEndpointURLs } from '@/constants'

import { MemberProvider } from './MemberContext'
import { useAuthContext } from './AuthContext'

const { publicRuntimeConfig } = getConfig()

const MemberProviderWrapper = ({ children }: { children: React.ReactNode }) => {
  const { setIsAuthenticated } = useAuthContext()

  return (
    <MemberProvider
      authenticationPathUrl={PublicApiEndpointURLs.AUTHENTICATION_PATH_URL}
      axiosOptions={{
        baseURL: publicRuntimeConfig.PUBLIC_API_URL,
      }}
      onError={() => {
        setIsAuthenticated(false)
      }}
      onSuccess={() => setIsAuthenticated(true)}
    >
      {children}
    </MemberProvider>
  )
}

export default MemberProviderWrapper
